import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { MbscNotificationsModule } from '@mobiscroll/angular';
import { importProvidersFrom } from '@angular/core';
import { MbscEventcalendar } from '@mobiscroll/angular';
import { provideHttpClient, withJsonpSupport } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';
import { registerLicense } from '@syncfusion/ej2-base';
import { IconSetService } from '@coreui/icons-angular';

registerLicense(environment.syncfusionKey);

bootstrapApplication(AppComponent, {
  providers: [
    provideAnimations(),
    provideAnimationsAsync(),
    ...appConfig.providers,
    importProvidersFrom(MbscNotificationsModule),
    provideHttpClient(withJsonpSupport()),
    provideRouter(routes),
    IconSetService
  ]
}).catch((err) => console.error(err));